import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function ProtectedRoute({ children, requiredRole }) {
  const { isAuthenticated, isDriver, isRider } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    const loginPath =
      requiredRole === "driver" ? "/driver-login" : "/user-login";
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }
  if (requiredRole === "driver" && !isDriver) {
    return <Navigate to="/" replace />;
  }
  if (requiredRole === "rider" && !isRider) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default ProtectedRoute;
